export default __webpack_public_path__ + "static/media/vision_icon.f06d3f45.svg";